import { render } from "./ArrivalUBN.vue?vue&type=template&id=33af0e10"
import script from "./ArrivalUBN.vue?vue&type=script&lang=js"
export * from "./ArrivalUBN.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__